import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Link} from 'react-router-dom';
import * as rolesUtils from '../services/access/utils';
import {topNavbar} from './navigation/items/profileItems';
import { injectIntl } from 'react-intl';
import {messages} from  './common/Translations';
import * as subscriptionTypes from "./company/subscriptionType";

class TopNavbar extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        return (
            <li className="list-inline-item dropdown notification-list">
                <a className="nav-link dropdown-toggle arrow-none 1waves-effect top-navbar__container" data-toggle="dropdown" href="#"
                   role="button" aria-haspopup="false" aria-expanded="false">
                    <i className="mdi mdi-account top-navbar__icon "/>
                    <div className="arrow-down"/>
                </a>
                <div className="dropdown-menu dropdown-menu-right dropdown-arrow dropdown-menu-lg">
                    <div className="notify-item text-muted font-14 pl-4">{this.props.intl.formatMessage(messages.topBarLabelSystem)}</div>
                    {
                            topNavbar.map((listItem, key) => {
                                if (rolesUtils.rolesHasAccess(this.props.roles, listItem.roles)
                                    && rolesUtils.subscriptionTypeHasAccess(this.props, listItem.subscriptionTypes)) {
                                    return (
                                        <Link
                                            key={key}
                                            to={listItem.to}
                                            className="dropdown-item"
                                        >
                                            <i className={`${listItem.icon} pull-right font-20`} />
                                            {listItem.title}
                                        </Link>
                                    )
                                }
                            })
                    }
                    <hr className="my-2"/>
                    <div className="notify-item text-muted font-14 ml-1">{this.props.intl.formatMessage(messages.topBarLabelActions)}</div>
                    <a
                        href="./logout"
                        className="dropdown-item">
                        <i className="mdi mdi-logout pull-right font-20"/>{this.props.intl.formatMessage(messages.topBarLabelLogOut)}
                    </a>
                </div>
            </li>
        );
    }
}


function mapStateToProps(state, ownProps) {
    return {
        roles: state.user.roles,
        user: state.user
    };
}

export default injectIntl(connect(mapStateToProps)(TopNavbar));


// WEBPACK FOOTER //
// ./web/src/components/TopNavbar.jsx